import React from 'react';
import BlogCard from '../components/blog/BlogCard';
import { blogPosts } from '../data/blogPosts';

const BlogPage = () => {
  return (
    <>
      <section className="bg-white px-6 py-14 md:px-12">
        <div className="mx-auto max-w-6xl text-center">
          <h1 className="text-3xl font-bold uppercase text-accent md:text-4xl">
            Blogs
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-gray-700 md:text-lg">
            Stories, updates, and insights from Drishtikon Himmatwaali Mission —
            celebrating courage and community across India.
          </p>
        </div>
      </section>

      <section className="bg-bg-light px-6 pb-14 md:px-12 md:pb-16">
        <div className="mx-auto grid max-w-6xl gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </section>
    </>
  );
};

export default BlogPage;
